module.exports = __webpack_public_path__ + "img/vehicle.8b0dc758.svg";